module.exports = __webpack_public_path__ + "img/icon.6491323e.png";